/* eslint-disable react/prop-types,no-shadow */
import React from 'react';
import { Table } from 'antd';
import { connect } from 'react-redux';
import { objTypeAndClassTypeMap } from 'config/app.config';
import { Panel } from 'components/ui/index';
import { SearchFieldFilter } from 'components/page/index';
import { injectIntl } from 'react-intl';
import { toTimezone } from 'utils/dateTimeUtils';
import Enums from 'utils/EnumsManager';
import { Link } from 'react-router-dom';
import { addToSelection, resetFilterValue } from 'components/page/ObjectFilter/components/FieldsSelection/flow/actions';
import { fetchResultByObjtype, fetchObjectAllFields, updateModuleColumnsByType, fetchObjectSelectedField } from '../flow/action';


const { FieldTypes } = Enums;
const {
  DateOnly,
  DateTime,
  Email,
  LongText,
  Lookup,
  NumberInput,
  PickList,
  TextInput,
} = FieldTypes;


class GlobalSearch extends React.Component {
    parsePagination = (objType) => {
      const { fetchResultByObjtype, keys } = this.props;
      const pagination = this.props.paginations[objType];
      // set the max data to due with max page is 5
      const maxData = pagination.total < pagination.perPage * 5 ? pagination.total : pagination.perPage * 5;
      return {
        defaultCurrent: pagination.currentPage,
        current: pagination.currentPage,
        defaultPageSize: pagination.perPage,
        pageSize: pagination.perPage,
        total: maxData,
        onChange(page, pageSize) {
          fetchResultByObjtype(objType, keys, pageSize, page);
        },
      };
    }

    renderColumnByType = (type, column, objectType) => {
      const configs = {
        title: column.field_label,
        dataIndex: column.field_name,
        columnId: column.id, // customized property, used by table sorter
      };
      const extraConfigs = {};

      switch (type) {
        case DateOnly:
        case DateTime:
          extraConfigs.render = text => {
            return text ? toTimezone(text, '+1100', 'YYYY-MM-DD') : '-';
          };
          break;
        case Lookup:
          extraConfigs.render = (lookup, record) => {
            if (lookup) {
              if (column.field_name === 'target_account_id' && record.target_account_id && record.target_account_id.id) {
                return (
                  <Link
                    className={`account-theme-text`}
                    to={`accounts/${record.target_account_id.id}`}
                  >
                    {lookup}
                  </Link>
                );
              }
              return lookup;
            }
            return '-';
          };
          extraConfigs.dataIndex = `${column.field_name}.${column.lookup_own_field_name}`;
          break;
        case PickList:
        case Email:
        case LongText:
        case NumberInput:
        case TextInput:
          extraConfigs.render = (text, record) => {
          // As requested, we use Name and Email fields as a entry point to object details
            if (text) {
              if (column.field_name === 'name' || column.field_name === 'email') {
                const theme = objTypeAndClassTypeMap[objectType];
                return (
                  <Link className={`${theme}-theme-text`} to={`${objectType}/${record.id}`}>
                    {text}
                  </Link>);
              }
              return text;
            }
            return '-';
          };
          break;
        default:
          throw new Error('No such type is found when set up column.');
      }

      return {
        ...configs,
        ...extraConfigs,
      };
    }

    renderColumns = (objType) => {
      const { columnsMeta } = this.props;
      const columns = columnsMeta[objType].map(column => this.renderColumnByType(column.crm_data_type, column, objType));
      return columns;
    }

    render() {
      const {
        result,
        columnsMeta,
        selectedFields,
        isDefaultField,
        addToSelection,
        resetFilterValue,
        fetchObjectAllFields,
        updateModuleColumnsByType,
        fetchObjectSelectedField,
      } = this.props;
      const { formatMessage } = this.props.intl;

      return (
        <div>
          {
            Object.keys(this.props.result).map(objType => (
              <Panel
                key={objType}
                panelClasses={`${objTypeAndClassTypeMap[objType]}-theme-panel`}
                panelTitle={formatMessage({ id: `global.properNouns.${objType}` })}
                actionsRight={
                  <SearchFieldFilter
                    theme={objTypeAndClassTypeMap[objType]}
                    objectType={objType}
                    fetchObjectAllFields={fetchObjectAllFields}
                    fetchObjectSelectedField={fetchObjectSelectedField}
                    searchLayout={columnsMeta[objType]}
                    addToSelection={addToSelection}
                    updateModuleColumnsByType={updateModuleColumnsByType}
                    selectedFields={selectedFields}
                    isDefaultField={isDefaultField}
                    resetFilterValue={resetFilterValue}
                    needRestore
                  />
                }
              >
                <Table
                  columns={this.renderColumns(objType)}
                  dataSource={result[objType]}
                  pagination={this.parsePagination(objType)}
                  rowKey="id"
                  size="small"
                  className="full-width-table"
                />
              </Panel>
            ))
            }
        </div>);
    }
}

const mapStateToProps = ({ globalSearch, objectView }) => ({
  result: globalSearch.globalSearchResult,
  keys: globalSearch.globalSearchKey,
  paginations: globalSearch.paginations,
  columnsMeta: globalSearch.globalSearchColumnsMeta,
  selectedFields: objectView.fields.selectedFields,
  isDefaultField: objectView.fields.isDefaultField,
});
const mapDispatchToProp = {
  fetchResultByObjtype,
  addToSelection,
  resetFilterValue,
  fetchObjectAllFields,
  updateModuleColumnsByType,
  fetchObjectSelectedField,
};


export default connect(mapStateToProps, mapDispatchToProp)(injectIntl(GlobalSearch));



// WEBPACK FOOTER //
// ./src/views/GlobalSearch/container/index.jsx